import QuotationBoards from "app/pages/Booking/Quotation/Board/QuotationBoards";
import { FormattedMessage } from "react-intl";
import QuotationRooms from "app/pages/Booking/Quotation/Accommodation/QuotationRooms";
import get from "lodash/get";
import PropTypes from "prop-types";
import "./QuotationRoomsBoards.scss";

const QuotationRoomsBoards = ({
	shouldShowBoardsFirst,
	boards = [],
	onBoardChange,
	onAccommodationChange,
	accommodations = [],
	accommodationsOfSelectedBoard = [],
	booking = {},
	boardsOfSelectedAccommodation = [],
	stressMarketingLabel,
}) => {
	return (
		<div className="quotation-rooms-boards">
			{shouldShowBoardsFirst ? (
				<>
					<div className="quotation-rooms-boards__item">
						<QuotationBoards
							title={
								<FormattedMessage
									id={
										boards.length > 1
											? "quotation.board.subtitle.several"
											: "quotation.board.subtitle.unique"
									}
									values={{
										step: 1,
									}}
								/>
							}
							boards={boards}
							onChange={onBoardChange}
						/>
					</div>

					<div className="quotation-rooms-boards__item">
						<QuotationRooms
							title={
								<FormattedMessage
									id={
										accommodationsOfSelectedBoard.length > 1
											? "quotation.accommodation.subtitle.several"
											: "quotation.accommodation.subtitle.unique"
									}
									values={{ step: 2 }}
								/>
							}
							accommodations={accommodationsOfSelectedBoard}
							contractType={get(booking, "offer.contractType")}
							onChange={onAccommodationChange}
							stressMarketingLabel={stressMarketingLabel}
						/>
					</div>
				</>
			) : (
				<>
					<div className="quotation-rooms-boards__item">
						<QuotationRooms
							title={
								<FormattedMessage
									id={
										accommodations.length > 1
											? "quotation.accommodation.subtitle.several"
											: "quotation.accommodation.subtitle.unique"
									}
									values={{ step: 1 }}
								/>
							}
							accommodations={accommodations}
							contractType={get(booking, "offer.contractType")}
							onChange={onAccommodationChange}
							stressMarketingLabel={stressMarketingLabel}
						/>
					</div>

					<div className="quotation-rooms-boards__item">
						<QuotationBoards
							boards={boardsOfSelectedAccommodation}
							title={
								<FormattedMessage
									id={
										boardsOfSelectedAccommodation.length > 1
											? "quotation.board.subtitle.several"
											: "quotation.board.subtitle.unique"
									}
									values={{
										step: 2,
									}}
								/>
							}
							onChange={onBoardChange}
						/>
					</div>
				</>
			)}
		</div>
	);
};

QuotationRoomsBoards.propTypes = {
	shouldShowBoardsFirst: PropTypes.bool,
	boards: PropTypes.arrayOf(PropTypes.any),
	onBoardChange: PropTypes.func,
	accommodationsOfSelectedBoard: PropTypes.arrayOf(PropTypes.any),
	booking: PropTypes.any,
	onAccommodationChange: PropTypes.func,
	accommodations: PropTypes.any,
	boardsOfSelectedAccommodation: PropTypes.any,
	stressMarketingLabel: PropTypes.string,
};

export default QuotationRoomsBoards;
